import { isEmpty } from 'lodash-es';
import { AgeRange } from '../types/age-range';

interface HasCompletedIntroSelectionsProps {
  selectedZipcode?: string;
  selectedCreditScoreId?: string;
  selectedIsOver25?: boolean;
  selectedAgeRangeId?: string;
  /** Should we assess age on age range or is over 25? */
  isUsingAgeRange: boolean;
  /** TODO: Temporary param to traverse cases where customer has the age range id of "null", this will force customers to be re-prompted for an age range selection */
  ageRanges?: AgeRange[];
}

export default function hasCompletedIntroSelections({
  selectedZipcode,
  selectedCreditScoreId,
  selectedIsOver25,
  selectedAgeRangeId,
  isUsingAgeRange,
  ageRanges,
}: HasCompletedIntroSelectionsProps) {
  const hasSelectedZipcode = !isEmpty(selectedZipcode);
  const hasSelectedCreditAge =
    !isEmpty(selectedCreditScoreId) &&
    (isUsingAgeRange
      ? !isEmpty(selectedAgeRangeId) &&
        ageRanges?.some((ageRange) => ageRange.id === selectedAgeRangeId)
      : selectedIsOver25 !== null || selectedIsOver25 !== undefined); // Have to check null or undefined rather than isEmpty for isOver25 as its a boolean

  return {
    hasSelectedZipcode,
    hasSelectedCreditAge,
    hasSelectedZipcodeCreditAge: hasSelectedZipcode && hasSelectedCreditAge,
  };
}
